import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { Button, ButtonGroup, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@material-ui/core";
import { Replay } from "@material-ui/icons";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AssistantIcon from "@material-ui/icons/Assistant";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles(theme => ({
	actionButtons: {
		marginRight: 6,
		flex: "none",
		alignSelf: "center",
		marginLeft: "auto",
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(0.5),
	},
	splitArrow: {
		padding: "0 4px",
		minWidth: 28,
		borderLeft: "1px solid rgba(255,255,255,0.3) !important",
	},
}));

const TicketActionButtonsCustom = ({ ticket }) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = useState(null);
	const [loading, setLoading] = useState(false);
	const ticketOptionsMenuOpen = Boolean(anchorEl);
	const { user } = useContext(AuthContext);
	const { setCurrentTicket } = useContext(TicketsContext);
	const [summaryOpen, setSummaryOpen] = useState(false);

	const handleOpenTicketOptionsMenu = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleCloseTicketOptionsMenu = () => {
		setAnchorEl(null);
	};

	const handleUpdateTicketStatus = async (e, status, userId) => {
		setLoading(true);
		try {
			await api.put(`/tickets/${ticket.id}`, {
				status: status,
				userId: userId || null,
				useIntegration: status === "closed" ? false : ticket.useIntegration,
				promptId: status === "closed" ? false : ticket.promptId,
				integrationId: status === "closed" ? false : ticket.integrationId,
			});

			setLoading(false);
			if (status === "open") {
				setCurrentTicket({ ...ticket, code: "#open" });
			} else {
				setCurrentTicket({ id: null, code: null });
				history.push("/tickets");
			}
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	return (
		<div className={classes.actionButtons}>
			{ticket.aiSummary && (
				<>
					<Tooltip title="Ver resumo da IA">
						<IconButton size="small" onClick={() => setSummaryOpen(true)} style={{ color: "#7c3aed" }}>
							<AssistantIcon fontSize="small" />
						</IconButton>
					</Tooltip>
					<Dialog open={summaryOpen} onClose={() => setSummaryOpen(false)} maxWidth="sm" fullWidth>
						<DialogTitle style={{ display: "flex", alignItems: "center", gap: 8, paddingBottom: 8 }}>
							<AssistantIcon style={{ color: "#7c3aed", fontSize: 20 }} />
							<span style={{ fontSize: 16, fontWeight: 600 }}>Resumo do atendimento pela IA</span>
						</DialogTitle>
						<DialogContent dividers>
							<Typography
								style={{
									whiteSpace: "pre-wrap",
									lineHeight: 1.7,
									fontSize: 14,
									color: "inherit"
								}}
							>
								{ticket.aiSummary}
							</Typography>
						</DialogContent>
						<DialogActions>
							<Button onClick={() => setSummaryOpen(false)} color="primary" variant="contained" size="small">
								Fechar
							</Button>
						</DialogActions>
					</Dialog>
				</>
			)}

			{ticket.status === "closed" && (
				<ButtonWithSpinner
					loading={loading}
					startIcon={<Replay />}
					size="small"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{i18n.t("messagesList.header.buttons.reopen")}
				</ButtonWithSpinner>
			)}

			{ticket.status === "open" && (
				<>
					<ButtonGroup variant="contained" color="primary" size="small" disableElevation>
						<Button
							startIcon={!loading ? <CheckCircleIcon style={{ fontSize: 16 }} /> : null}
							onClick={e => handleUpdateTicketStatus(e, "closed", user?.id)}
							disabled={loading}
							style={{ fontWeight: 600, letterSpacing: 0.3 }}
						>
							{i18n.t("messagesList.header.buttons.resolve")}
						</Button>
						<Button
							className={classes.splitArrow}
							onClick={handleOpenTicketOptionsMenu}
							disabled={loading}
						>
							<KeyboardArrowDownIcon style={{ fontSize: 18 }} />
						</Button>
					</ButtonGroup>
					<TicketOptionsMenu
						ticket={ticket}
						anchorEl={anchorEl}
						menuOpen={ticketOptionsMenuOpen}
						handleClose={handleCloseTicketOptionsMenu}
						onReturn={() => handleUpdateTicketStatus(null, "pending", null)}
					/>
				</>
			)}

			{ticket.status === "pending" && (
				<ButtonWithSpinner
					loading={loading}
					size="small"
					variant="contained"
					color="primary"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{i18n.t("messagesList.header.buttons.accept")}
				</ButtonWithSpinner>
			)}
		</div>
	);
};

export default TicketActionButtonsCustom;
